import { useNavigate } from "react-router-dom";

import { LoginOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Card, Col, Divider, Form, Image, Input, notification, Row, Space, Typography } from "antd";

import { useLoginMutation } from "api/authApi";
import Logo from "assets/images/download.png";
import { OBJ_COLOR, USER_LIST } from "commons/constants";
import { setUser } from "slice";
import { useAppDispatch } from "store";
import styled from "styled-components";

const { Title } = Typography;

const WrapperBoxLogin = styled.div`
	height: 100vh;
	display: flex;
	justifycontent: center;
	aligncontent: center;
`;
const CardLoginCustom = styled(Card)`
	box-shadow: rgb(0 0 0 / 16%) 0px 1px 2px -2px, rgb(0 0 0 / 12%) 0px 3px 6px 0px, rgb(0 0 0 / 9%) 0px 5px 12px 4px;
	background-size: cover;
	margin: auto;
	height: 550px;
	width: 400px;
	border-color: transparent;
`;

export const Authentication = () => {
	const dispatch = useAppDispatch();

	const navigate = useNavigate();
	const [login, { isLoading }] = useLoginMutation();

	const onFinish = async (values: { userId: string; password: string }) => {
		try {
			if (!USER_LIST.includes(values.userId)) {
				return notification["error"]({
					message: "Tài khoản hoặc mật khẩu không đúng",
				});
			}

			const data = await login(values).unwrap();
			dispatch(setUser(data));
			navigate("/admin/users", { replace: true });
		} catch (error: any) {
			notification["error"]({
				message: "Tài khoản hoặc mật khẩu không đúng",
			});
		}
	};

	return (
		<WrapperBoxLogin>
			<CardLoginCustom>
				<Row gutter={[0, 8]} justify="center">
					<Col xs={20} style={{ textAlign: "center" }}>
						<Space align="center" style={{ marginBottom: 5 }}>
							<Image width={90} src={Logo} preview={false} />
						</Space>
					</Col>
					<Col xs={20}>
						<Divider>
							<Title style={{ color: OBJ_COLOR.SUCCESS, marginBottom: 0 }} level={5}>
								<span style={{ color: OBJ_COLOR.INFO }}>SURVEY </span>
							</Title>
						</Divider>
					</Col>
					<Col xs={20}>
						<Form layout="vertical" name="basic" onFinish={onFinish}>
							<Form.Item required label="Employee ID" name="userId" rules={[{ required: true, message: "Please input your username!" }]}>
								<Input suffix={<UserOutlined />} />
							</Form.Item>
							<Form.Item required label="Password" name="password" rules={[{ required: true, message: "Please input your password!" }]}>
								<Input.Password />
							</Form.Item>

							<Form.Item>
								<Space style={{ justifyContent: "space-between", width: "100%", marginTop: "0" }}>
									<div style={{ display: "flex", justifyContent: "space-between" }}>
										<a href="https://gfportal.greenfeed.com.vn:9898/account/forgotpassword?redirecturl=https://okr.greenfeed.com.vn:6868" target="_blank" rel="noreferrer" style={{ color: OBJ_COLOR.INFO }}>
											Forgot Password?
										</a>
									</div>
								</Space>
							</Form.Item>

							<Form.Item>
								<Button loading={isLoading} icon={<LoginOutlined />} style={{ width: "100%" }} type="primary" htmlType="submit">
									Login
								</Button>
							</Form.Item>
						</Form>
					</Col>
				</Row>
			</CardLoginCustom>
		</WrapperBoxLogin>
	);
};
